module.exports = __webpack_public_path__ + "static/media/icon-contact-inactive.ef7e34ca.svg";